// extracted by mini-css-extract-plugin
module.exports = {"RemixPublished":"RemixComment_RemixPublished__RDGTG","ThumbnailImage":"RemixComment_ThumbnailImage__Tib9H","PublishText":"RemixComment_PublishText__xZ_YY"};